export default __webpack_public_path__ + "static/media/MaskGroup341.8dce93ea.png";